

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";
  import {IOnOffHandlers} from "bonomo/dist";
  import {ELockerStatuses, ILocker} from "@/model/Locker/lockerInterfaces";
  import {IScreensaver} from "@/model/Screensaver/screensaverInterfaces";
  import LockerChip from "@/components/shared/chips/LockerChip.vue";
  import LockerStatusChip from "@/components/shared/chips/LockerStatusChip.vue";
  import {Watch} from "vue-property-decorator";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
  import ScreensaverLogs from "@/components/user/logs/ScreensaverLogs.vue";

  const lockerModule = namespace("lockerModule");
  const screensaverModule = namespace("screensaverModule");

  interface ILockerWithConnect extends ILocker {
    connectModel: boolean;
  }

  @Component({
    name: 'ScreensaversLockers',
    components: {
      LockerStatusChip,
      LockerChip,
      ScreensaverLogs,
    }
  })
  export default class LockersScreensaversView extends Vue {

    @lockerModule.Getter('lockers')
    private lockers!: ILocker[];

    @screensaverModule.Getter('screensavers')
    private screensavers!: IScreensaver[];
    @screensaverModule.Getter('screensaversLockerIds')
    private connectedIds!: number[];

    @Watch('$route')
    onUrlChanged($route: any) {
      this.loadData();
    }

    private screensaverId: number = 0;
    private screensaver?: IScreensaver;
    private lockerItems: ILockerWithConnect[] = [];
    private search: string = '';
    private onlyActive: boolean = true;
    private onlyAssigned: boolean = true;
    private filteredCnt: number = 0;
    private connectionsLoading: boolean = true;
    private subscribes: IOnOffHandlers = {};

    protected get headers(): BetterDataTableHeader[] {
      return [
        {text: this.$t('common.id'), align: 'start', sortable: true, value: 'id'},
        // { text: 'Orden', align: 'start', value: 'order' },
        {text: this.$t('common.locker'), align: 'start', value: 'name'},
        {text: this.$t('common.status'), align: 'center', value: 'status'},
        {text: this.$t('common.which'), align: 'center', value: 'shareCta', sortable: false},
        {text: this.$t('common.assigned'), align: 'center', value: 'connectModel'},
      ];
    }

    get screensaverItems() {
      const screensavers = this.screensavers;
      const ret = (screensavers || [])
        .map((screensaver: IScreensaver) => ({
          text: screensaver.name + ' (#' + screensaver.id + ')',
          value: screensaver.id,
        }));
      ret.unshift({
        text: '',
        value: 0,
      });
      return ret;
    }

    get combinedSearch() {
      // we make sure search is triggered even when search input is empty. otherwise our custom filter is not applied
      //  also A : B ensures that seach changes when the active/assigned switch changes
      return (this.search||'').toString() +
        (this.onlyAssigned ? 'A' : 'B') +
        (this.onlyActive ? 'A' : 'B');
    }

    created() {
      this.loadData(true);
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
        'backend.call.OK.screensaversLoaded': this.onScreensaversLoaded,
        'backend.call.OK.lockersLoaded': this.onLockersLoaded,
        'backend.call.OK.connectionIdsLoaded': this.makeLockerItems,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    private loadData(initial: boolean = false) {
      // load only if it's a reload (not initial), or if there are no lockers
      if (!initial || !this.lockers || !this.lockers.length) {
        this.$store.dispatch('lockerModule/fetchLockers');
      }
      else {
        this.onLockersLoaded();
      }
      if (!initial || !this.screensavers || !this.screensavers.length) {
        this.$store.dispatch('screensaverModule/fetchScreensavers');
      }
      else {
        this.onScreensaversLoaded();
      }
    }

    private onScreensaverSelected(screensaverId: number) {
      this.connectionsLoading = true;
      this.screensaverId = screensaverId;
      this.screensaver = this.screensavers.find((each) => each.id == this.screensaverId);
      this.$router.push({name: 'screensaversLockers', params: {screensaverId: ''+screensaverId}});
      Vue.nextTick(
        () => this.$store.dispatch('screensaverModule/fetchScreensaversLockerIds', this.screensaverId)
      );
    }

    private onScreensaversLoaded() {
      Vue.nextTick(() => this.onScreensaverSelected(
        parseInt(this.$route.params.screensaverId) || 0
      ));
    }

    private lockersFilter(
      value: any,
      search: string,
      item: ILockerWithConnect
    ) {
      const notBySearch = this.search.length &&
        (value||'').toString().toLowerCase().indexOf(this.search.toLowerCase()) === -1
      const notByActive = this.onlyActive && item.status != ELockerStatuses.Install && item.status != ELockerStatuses.Online;
      const notByAssigned = this.onlyAssigned && !item.connectModel;
      return !notBySearch && !notByActive && !notByAssigned;
    }

    private onLockersLoaded() {
      this.lockerItems = this.lockers.map(
        each => Object.assign({}, each, {connectModel: false})
      );
      this.makeLockerItems();
    }

    private makeLockerItems() {
      this.lockerItems.forEach(
        (each) => each.connectModel = this.hasLocker(each.id)
      );
      this.connectionsLoading = false;
    }

    private hasLocker(lockerId: number) {
      return this.connectedIds.indexOf(lockerId) !== -1;
    }

    private onSwitch(lockerId: number, connected: boolean) {
      this.connectionsLoading = true;
      this.$store.dispatch(
        'screensaverModule/connectLockerScreensaver',
        {
          lockerId,
          screensaverId: this.screensaverId,
          connected
        }
      );
    }

    private onFilteredChanged(e: ILockerWithConnect[]) {
      this.filteredCnt = e.length;
    }

  }
